const logic = function(){
    var self = this;

    this.display = function(questions){
        const q2 = function(){
            return questions[1].value === 1;
        }

        return {
            2: function(){
                return q2()
            },
            3: function(){
                return q2() && questions[2].value===2
            },
            4: function(){
                return questions[3].value===3
            }
        }

    }

    this.actions = function(questions){
        return {
            3: function(){
                if(questions[3].value===1){
                    questions[3].controller.setValue(2)
                }
            }
        }
    }

    
}

export default logic;